import {inject} from '@angular/core';
import {Actions, ofType} from '@ngrx/effects';
import {createFunctionalEffect} from '@shared/utils/effects.helper';
import {AuthenticationActions} from '@state/authentication/authentication.actions';
import {
  EApiNotification,
  mapOdApiActions,
} from '@utils/map-od-api-actions.function';
import {exhaustMap, map, switchMap} from 'rxjs';

import {HistoryActions} from './history.actions';
import {HistoryApi} from './history.api';

export namespace HistoryEffects {
  export const getHistory$ = createFunctionalEffect(
    (actions$ = inject(Actions), api = inject(HistoryApi)) =>
      actions$.pipe(
        ofType(HistoryActions.getHistory.requested),
        exhaustMap(() =>
          api.getHistory().pipe(mapOdApiActions(HistoryActions.getHistory))
        )
      )
  );

  export const reloadOnLogin$ = createFunctionalEffect(
    (actions$ = inject(Actions)) =>
      actions$.pipe(
        ofType(AuthenticationActions.loginConfirm.succeeded),
        map(() => HistoryActions.getHistory.requested())
      )
  );

  export const saveToHistory$ = createFunctionalEffect(
    (actions$ = inject(Actions), api = inject(HistoryApi)) =>
      actions$.pipe(
        ofType(HistoryActions.saveToHistory.requested),
        switchMap(({subjectId}) =>
          api
            .saveToHistory(subjectId)
            .pipe(
              mapOdApiActions(
                HistoryActions.saveToHistory,
                EApiNotification.Never
              )
            )
        )
      )
  );
}
